import EnLeftData from './index.vue'
const EnLeft = {
  install:(Vue) => {
    Vue.component('EnLeft',EnLeftData)
  }
}
export default EnLeft


// WEBPACK FOOTER //
// ./src/components/english/engleft/index.js